module.exports = __webpack_public_path__ + "img/button_rule.2550abc3.png";